import { Blueprint } from "./Blueprint";

export function BlueprintPage() {
  return <Blueprint />;
}
